export default __webpack_public_path__ + "static/media/at the museum..ee71b60a.jpg";